module.exports = __webpack_public_path__ + "53bb6173c6cc62d65a33d8f2a8063add.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/photo-backgrounds/black-and-white-images/B_W1.jpg
// module id = 3489
// module chunks = 0